import React, { useRef } from 'react';
import { Icon, Text } from '@msc-b2c/shared-components';
import { FlowSelectableCardProps } from '@msc-b2c/interfaces/interfaces';
import {
  handleClickWithTouchScrollGuard,
  handleTouchMoveForScrollGuard,
  handleTouchStartForScrollGuard,
  resetTouchScrollGuard,
} from '../../utils/touchScrollGuardUtils';
import styles from './flowSelectableCard.module.scss';
import { getDeviceType } from '../../../../../../utils/utils';

export const FlowSelectableCard: React.FC<FlowSelectableCardProps> = ({
  primaryText,
  secondaryText,
  badgeText,
  isSelected = false,
  isDisabled = false,
  isConflict = false,
  onClick,
  compact = false,
  hideSecondaryOnCompact = false,
  icon,
}) => {
  const touchStartRef = useRef<{ x: number; y: number } | null>(null);
  const hasTouchMovedRef = useRef(false);

  const showSecondary = Boolean(secondaryText) && !(compact && hideSecondaryOnCompact);

  return (
    <button
      type="button"
      className={`${styles['flow-selectable-card']} ${
        isSelected ? styles['flow-selectable-card--selected'] : ''
      } ${isDisabled ? styles['flow-selectable-card--disabled'] : ''} ${
        isConflict ? styles['flow-selectable-card--conflict'] : ''
      } ${compact ? styles['flow-selectable-card--compact'] : ''} ${
        icon ? styles['flow-selectable-card--with-icon'] : ''
      } ${getDeviceType() === 'desktop' ? '-hover' : ''}`}
      onTouchStart={(event) =>
        handleTouchStartForScrollGuard(event, touchStartRef, hasTouchMovedRef)
      }
      onTouchMove={(event) => handleTouchMoveForScrollGuard(event, touchStartRef, hasTouchMovedRef)}
      onTouchEnd={() => resetTouchScrollGuard(touchStartRef)}
      onTouchCancel={() => resetTouchScrollGuard(touchStartRef)}
      onClick={(event) => handleClickWithTouchScrollGuard(event, hasTouchMovedRef, onClick)}
      disabled={isDisabled}
      aria-pressed={isSelected}
    >
      {!!icon && (
        <Icon
          icon={icon}
          styleOption={styles['flow-selectable-card__icon']}
        />
      )}
      <div className={styles['flow-selectable-card__content']}>
        <div className={styles['flow-selectable-card__header']}>
          <div className={styles['flow-selectable-card__primary']}>
            <Text
              text={primaryText}
              styleOption="body-default"
            />
          </div>
          {badgeText && <span className={styles['flow-selectable-card__badge']}>{badgeText}</span>}
        </div>
        {showSecondary && (
          <div className={styles['flow-selectable-card__secondary']}>
            <Text
              text={secondaryText || ''}
              styleOption="body-default"
            />
          </div>
        )}
      </div>
    </button>
  );
};

export default FlowSelectableCard;
